module.exports = __webpack_public_path__ + "static/img/RiskInfo_Banner.f140f00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FFP/images/RiskInfo_Banner.png
// module id = oOFD
// module chunks = 0